/// <amd-module name="VSS/Features/PlatformUI/ContributedContent" />
export { ContributedContent } from "./Components/ContributedContent/ContributedContent";
export { IContributedContentProps } from "./Components/ContributedContent/ContributedContent.Props";
